// extracted by mini-css-extract-plugin
export default {"container":"Tabs_container__AlBF1","tight":"Tabs_tight__v9b-J","tab":"Tabs_tab__kkhRp","active":"Tabs_active__PsLwO","spin":"Tabs_spin__ymyfa"};